import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyA7LFvA6_6-Nip1hcgf-FNa5wKQp0QJ4FA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "arvind-portfolio-blog.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "arvind-portfolio-blog",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "arvind-portfolio-blog.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "332909086729",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:332909086729:web:4e8159a472d6352b2a90d8",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-RE0DM7QGP5"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const storage = getStorage(app);

export { db, auth, googleProvider, storage }; 